import { getDefaultPreset, PRESET_SCHEMA_VERSION } from './defaultPreset';

const TENEMENT_DATE_FIELDS = ['startDate', 'endDate', 'grantDate'];

const isPlainObject = (v) =>
  v !== null && typeof v === 'object' && !Array.isArray(v) && !(v instanceof Date);

export function deepClone(value) {
  if (value instanceof Date) return new Date(value.getTime());
  if (Array.isArray(value)) return value.map(deepClone);
  if (isPlainObject(value)) {
    const out = {};
    for (const k of Object.keys(value)) out[k] = deepClone(value[k]);
    return out;
  }
  return value;
}

function deepMergeOntoDefaults(defaults, stored) {
  if (!isPlainObject(stored)) return deepClone(defaults);
  const out = {};
  for (const key of Object.keys(defaults)) {
    const d = defaults[key];
    const s = stored[key];
    if (s === undefined) {
      out[key] = deepClone(d);
    } else if (isPlainObject(d) && isPlainObject(s)) {
      out[key] = deepMergeOntoDefaults(d, s);
    } else {
      out[key] = deepClone(s);
    }
  }
  return out;
}

export function presetToFirestore(preset) {
  const payload = deepClone(preset.payload);
  if (payload.tenementFilters) {
    for (const f of TENEMENT_DATE_FIELDS) {
      const v = payload.tenementFilters[f];
      if (v instanceof Date) {
        payload.tenementFilters[f] = v.toISOString();
      }
    }
  }
  const nowIso = new Date().toISOString();
  return {
    name: preset.name,
    version: PRESET_SCHEMA_VERSION,
    createdAt: preset.createdAt || nowIso,
    updatedAt: nowIso,
    payload,
  };
}

export function presetFromFirestore(docSnap) {
  const raw = docSnap.data();
  const storedPayload = raw?.payload ? deepClone(raw.payload) : {};

  if (storedPayload.tenementFilters) {
    for (const f of TENEMENT_DATE_FIELDS) {
      const v = storedPayload.tenementFilters[f];
      if (typeof v === 'string') {
        const d = new Date(v);
        if (!isNaN(d.getTime())) storedPayload.tenementFilters[f] = d;
      }
    }
  }

  const merged = deepMergeOntoDefaults(getDefaultPreset(), storedPayload);

  return {
    id: docSnap.id,
    name: raw?.name || 'Untitled',
    version: raw?.version ?? PRESET_SCHEMA_VERSION,
    createdAt: raw?.createdAt || null,
    updatedAt: raw?.updatedAt || null,
    payload: merged,
    isBuiltIn: false,
  };
}

export function buildPresetPayloadFromCurrentState({
  overlayVisibility,
  layerVisibility,
  tenementFilters,
  minedexFilters,
  assayFilters,
  drillHoleFilters,
  assayMarkerColourSettings,
  drillHoleMarkerColourSettings,
}) {
  return {
    overlayVisibility: deepClone(overlayVisibility),
    layerVisibility: deepClone(layerVisibility),
    tenementFilters: deepClone(tenementFilters),
    minedexFilters: deepClone(minedexFilters),
    assayFilters: deepClone(assayFilters),
    drillHoleFilters: deepClone(drillHoleFilters),
    assayMarkerColourSettings: deepClone(assayMarkerColourSettings),
    drillHoleMarkerColourSettings: deepClone(drillHoleMarkerColourSettings),
  };
}
